import { render, staticRenderFns } from "./AdminFraudMonitoring.vue?vue&type=template&id=857f8938&scoped=true&"
import script from "./AdminFraudMonitoring.vue?vue&type=script&lang=js&"
export * from "./AdminFraudMonitoring.vue?vue&type=script&lang=js&"
import style0 from "./AdminFraudMonitoring.vue?vue&type=style&index=0&id=857f8938&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "857f8938",
  null
  
)

export default component.exports